export default {
  
  calculateCellHeight(text, fontSize, lineHeight, maxCharsPerLine) {
    // 1. テキストを改行で分割
    const lines = text.split('\n');
    // 2. 各行の高さを計算
    const totalLines = lines.reduce((sum, line) => {
    // 各行の長さに基づいて必要な行数を計算
     const lineCount = Math.ceil(line.length / maxCharsPerLine);
  
     return sum + lineCount; // 各行の行数を合計
     }, 0);
    // 3. 1行の高さを計算
    const lineHeightInPx = fontSize * lineHeight;

    // 4. 合計の高さを返す
    return totalLines * lineHeightInPx;
  },
  calculateCell(text, maxVisualCharsPerLine = 31) {
    const digitRatio = 31 / 58;
    const alphaRatio = 31 / 60;

    const lines = text.split('\n');
    let totalLines = 0;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      let visualLength = 0;

      for (let ch of line) {
        if (ch.match(/[ぁ-んァ-ン一-龯ー々가-힣]/)) {
          visualLength += 1;
        } else if ('★。、「」、⇒・【】（）'.includes(ch)) {
          visualLength += 1;
        } else if (ch.match(/[0-9]/)) {
          visualLength += digitRatio;
        } else if (ch.match(/[A-Za-z]/)) {
          visualLength += alphaRatio;
        } else if (ch.match(/\s/)) {
          visualLength += 0.25;
        } else {
          visualLength += 0.5;
        }
      }

      const lineCount = Math.ceil(visualLength / maxVisualCharsPerLine);
      totalLines += lineCount;
    }
    return totalLines;
  },
  calculateSpaces(text, desiredLength) {
    const currentLength = text.length;
    const spacesNeeded = desiredLength - currentLength > 0 ? desiredLength - currentLength : 0;

    return ' '.repeat(spacesNeeded);
  },

  generateCareerItems(skillSheetDatas) {
  const safeValue = (value) => value ?? " ";
  let isFirstPage = true;
  const pageHeightPt = 842;
  const fixedHeaderHeight = 115.7;
  const headerOnlyHeight = 52;

  let availableHeight = pageHeightPt - fixedHeaderHeight;
  let itemText = [];

  itemText.push([
    { text: '', fillColor: '#bcbcbc' },
    { text: '開発期間', alignment: 'center', fillColor: '#bcbcbc' },
    { text: '業務内容', alignment: 'center', fillColor: '#bcbcbc' },
    { text: '開発環境等', salignment: 'center', fillColor: '#bcbcbc' },
    { text: '役割', alignment: 'center', fillColor: '#bcbcbc' }
  ]);

  for (let j = 0; j < (skillSheetDatas.careerItemsData?.length || 0); j++) {
    const item = skillSheetDatas.careerItemsData[j];
    const isFixed = item.isFixed || 0;

    let businessText = safeValue(item.businessContent);
    let developmentEnvironment = safeValue(item.developmentEnvironment);
    let role = safeValue(item.role);

    const lineCount1 = this.calculateCell(businessText, 31);
    const lineCount2 = this.calculateCell(developmentEnvironment, 6);
    const lineCount3 = this.calculateCell(role, 7);
    const lineCount4 = 2;

    const maxLineCount = Math.max(lineCount1, lineCount2, lineCount3, lineCount4);

    let rowHeight;

    if (maxLineCount <= 19) {
      rowHeight = pageHeightPt * 0.27;

      businessText = this.truncateTextToLine(businessText, 31, 19, isFixed);
      developmentEnvironment = this.truncateTextToLine(developmentEnvironment, 6, 19, isFixed);
      role = this.truncateTextToLine(role, 7, 19, isFixed);
    } else {
      rowHeight = maxLineCount * 12;
    }
    if (isFirstPage) {
     if (rowHeight > 720) {
    availableHeight = (pageHeightPt - headerOnlyHeight) * 2 - rowHeight;
    isFirstPage = false;
  } else if (availableHeight - rowHeight < 0) {
    itemText.push([
        { text: '', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '開発期間', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '業務内容', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '開発環境等', salignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '役割', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' }
      ]);
    availableHeight = pageHeightPt - headerOnlyHeight - rowHeight;
    isFirstPage = false;
  } else {
    availableHeight -= rowHeight;
  }
} else {
  if (rowHeight > 790) {
    availableHeight = (pageHeightPt - headerOnlyHeight) * 2 - rowHeight;
    itemText.push([
        { text: '', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '開発期間', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '業務内容', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '開発環境等', salignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '役割', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' }
      ]);
  } else if (availableHeight - rowHeight < 0) {
    itemText.push([
        { text: '', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '開発期間', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '業務内容', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '開発環境等', salignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' },
        { text: '役割', alignment: 'center', pageBreak: 'before', fillColor: '#bcbcbc' }
      ]);
    availableHeight = pageHeightPt - headerOnlyHeight - rowHeight;
  } else {
    availableHeight -= rowHeight;
  }
}
 
    itemText.push([
      {
        text: j + 1,
        alignment: 'center',
        margin: [0, (rowHeight / 2), 0, 0],
        style: 'infoCI',
        lineHeight: 1.5,
        border: [true, true, true, true]
      },
      [
        {
          text: `${this.formatDate(item.developmentStartDate) ? this.formatDate(item.developmentStartDate) + '\n～\n' : ''} ${this.formatDate(item.developmentEndDate)}`,
          style: 'infoCI',
          margin: [0, 0, 0, 0],
          border: [true, true, true, true]
        },
        {
          text: item.developmentPeriod ? `\n（${item.developmentPeriod}）` : '',
          alignment: 'center',
          style: 'infoCI',
          border: [true, true, true, true]
        },
      ],
      { text: businessText, style: 'infoCI', margin: [0, 0, 5, 0], border: [true, true, true, true] },
      { text: developmentEnvironment, style: 'infoCI', margin: [0, 0, 5, 0], border: [true, true, true, true] },
      { text: role, style: 'infoCI', margin: [0, 0, 5, 0], border: [true, true, true, true] }
    ]);
  }

  return itemText;
},


  formatDate(dateString) {
    if (!dateString) {
      return "";
    }

    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}年${month}月${day}日`;
  },


  // ○を付ける処理
  getSkillLevelMark(filteredData, name, skillLevel) {
    const matchingData = filteredData.find(item => item.name === name && item.skillLevel === skillLevel);
    return matchingData ? '○' : '';
  },

  removeDuplicates(array) {
    const seen = new Set();

    return array.filter(row => {
      const classification = row[0]?.text?.trim() || '';
      const name = row[1]?.text || '';

      // 'DB', '暗号化/情報漏えい対策', 'その他'の場合、重複チェックをスキップ
      if (
        classification === 'ＤＢ' ||
        classification === '暗号化/情報漏えい対策' ||
        name
      ) {
        return true;
      }

      const key = JSON.stringify({ classification, name });

      // 重複チェックと追加
      if (!seen.has(key)) {
        seen.add(key);
        return true;
      }
      return false;
    });
  },

  truncateTextToLine(text, maxCharsPerLine, maxLines = 19, isFixed = 0) {
  const calculateLines = (txt) => {
    const lines = txt.split('\n').map(line => Math.ceil(line.length / maxCharsPerLine));
    return lines.reduce((sum, count) => sum + count, 0);
  };

  let finalText = text || '';
  let isTruncated = false;

  while (calculateLines(finalText) > maxLines) {
    finalText = finalText.substring(0, finalText.length - 1);
    isTruncated = true;
  }

  const currentLines = calculateLines(finalText);

  if (!isTruncated && (isFixed === 1 || currentLines <= maxLines)) {
    const linesToAdd = maxLines - currentLines;
    for (let i = 0; i < linesToAdd; i++) {
    finalText += '\n ';
    }
  }

  if (isTruncated) {
    finalText += '...';
  }

  return finalText;
},

  truncateTextToFit(text, maxHeight, fontSize, lineHeight, maxCharsPerLine, isFixed = 0) {
    const calculateHeight = (txt) => {
      const lines = txt.split('\n').map(line => Math.ceil(line.length / maxCharsPerLine));
      const totalLines = lines.reduce((sum, lineCount) => sum + lineCount, 0);
      return totalLines * (fontSize * lineHeight);
    };
  
    let truncatedText = text || '';
  
    let isTruncated = false;
    while (calculateHeight(truncatedText) > maxHeight) {
      truncatedText = truncatedText.substring(0, truncatedText.length - 1);
      isTruncated = true;
    }
    if (!isTruncated && isFixed === 1) {
      while (calculateHeight(truncatedText) < maxHeight) {
        truncatedText += '\n ';
      }
    }
    if (isTruncated) {
      truncatedText += '...';
    }
    return truncatedText;
  },

  generateLeftSkillSheetTable(skillSheetData) {
    /**
     * テクニカル・スキルシート（左）
     * 
     */
    const header = [
      {
        text: '分\n\n類',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 28, 0, 0],
        fillColor: '#FFFFCC'
      },
      {
        text: [
          { text: '名   称\n\n\n', style: 'subHeaderSk' },
          { text: '(右下の該当セルに○を付ける)', style: 'subHeaderSkRed' }, // 赤色
        ],
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 40, 0, 0],
      },
      {
        text: '基\n本\n知\n識\nの\nみ',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 3, 0, 0],
        fillColor: '#CCFFFF'
      },
      {
        text: '実\n戦\n経\n験\nあ\nる',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 3, 0, 0],
        fillColor: '#CCFFFF'
      },
      {
        text: '一\n人\nで\n実\n践\n可\n能',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 1, 0, 0],
        fillColor: '#CCFFFF'
      },
      {
        text: 'ユ\n｜\nザ\n指\n導\n可\n能',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 3, 0, 0],
        fillColor: '#CCFFFF'
      },
    ];

    const tableBody = [header];

    const classifications1 = [
      'OS / NOS',
      'システム設計構築',
      'システム管理',
      'システム運用',
      'サーバ技術',
      'ＮＷ技術',
      'クラウド仮想環境',
    ];

    const nameMapping1 = {
      "OS / NOS": [
        "Windows 7 各エディション",
        "Windows 8.1 各エディション",
        "Windows 10 各エディション",
        "Windows Embedded 各エディション",
        "Windows Server 2003 R2",
        "Windows Server 2008 R2",
        "Windows Server 2012 R2",
        "Linux（　CentoOS　）",
        "FreeBSD",
        "Solaris（SUN）",
        "HP-UX（HP）",
        "AIX（IBM）",
        "Android",
        "iOS",
        "メインフレーム（  MSP            ）",
        "Mac（          ）",
      ],
      システム設計構築: [
        "キャパシティプランニング",
        "ネットワーク設計（要件定義）",
        "ネットワーク設計（基本設計）",
        "ネットワーク設計（詳細設計）",
        "ネットワーク設計（構築・テスト）",
        "サーバ設計（要件定義）",
        "サーバ設計（基本設計）",
        "サーバ設計（詳細設計）",
        "サーバ設計（構築・テスト）",
        "端末設計（要件定義）",
        "端末設計（基本設計）",
        "端末設計（詳細設計）",
        "端末設計（構築・テスト）",
      ],
      システム管理: [
        "Systemwalker Centric Manager",
        "Systemwalker Operation Manager",
        "SKYSEA",
        "OpenView",
        "JP1",
        "Tivoli Enterprise",
        "HP Insight Manager",
        "HP SiteScope",
        "App Manager",
        "Nagios / Zabbix",
        "その他（Hinemos / AsteriaWarp）",
      ],
      システム運用: [
        "SNMP / MIB",
        "プロトコルの解析と分析",
        "ネットワーク故障対応",
        "サーバ故障対応",
        "端末・周辺機器故障対応",
        "ITILによるサービス運用",
      ],
      サーバ技術: [
        "ActiveDirectory、GPO",
        "DNS（Windows機能/BIND）",
        "Mail（Sendmail/ProcMail）",
        "Web（IIS/Apatch/TOMCAT/WebLogic）",
        "クラスタ(WSFC)",
        "LDAP（　　　　　　　）",
        "性能評価 / 冗長構成",
      ],
      ＮＷ技術: [
        "TCP/IP",
        "L2/L3スイッチ",
        "L4SW及びロードバランサー",
        "ルータ（　　　　　　　　）",
        "帯域制御装置（　　　　　　　）",
        "VPN（　　　　　　　）",
        "その他（　　　　　　　）",
      ],
      クラウド仮想環境: [
        "Microsoft azure",
        "Microsoft AD",
        "Microsoft intune",
        "VMware vSphere Hypervisor",
        "VMware horizon view",
        "Oracle VM Virtualbox",
        "その他（VMware Workstation）",
      ],
    };

    classifications1.forEach((classification) => {
      const toDisplayString = (str) => str.replace(/ー/g, "｜");
      const categoryNames = nameMapping1[classification] ? nameMapping1[classification] : [];

      const filteredData = skillSheetData.filter(item => item.classification === classification);
      categoryNames.forEach((name, index) => {

        let row = [];


        if (classification === "OS / NOS") {
          row.push(
            index === 0
              ? { text: toDisplayString(classification), margin: [0, 50, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          );
        }

        if (classification === "システム設計構築") {
          row.push(
            index === 0
              ? { text: toDisplayString(classification), margin: [0, 15, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          );
        }

        if (classification === "システム管理") {
          row.push(
            index === 0
              ? { text: toDisplayString(classification), margin: [0, 16, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          );
        }


        if (classification === "システム運用") { // 縦書き文字のサイズによってテーブルが拡大されたため、追加しました
          row.push(
            index === 0
              ? { text: classification, fontSize: 5.5, margin: [0, 0, 0, 0], alignment: 'center', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          )
        }

        if (classification === "サーバ技術") {
          row.push(
            index === 0
              ? { text: toDisplayString(classification), margin: [0, 4, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          );
        }

        if (classification === "ＮＷ技術") {
          row.push(
            index === 0
              ? { text: toDisplayString(classification), margin: [0, 9, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          );
        }

        if (classification === "クラウド仮想環境") { // 縦書き文字のサイズによってテーブルが拡大されたため、追加しました
          row.push(
            index === 0
              ? { text: classification, fontSize: 5, margin: [0, 0, 0, 0], alignment: 'center', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
              : '', // 右の分類
          )
        }

        row.push(
          { text: name, style: 'infoSk', alignment: 'left' }, // 左の名称
          {
            text: this.getSkillLevelMark(filteredData, name, '基本知識のみ'),
            style: 'infoSkBold',
            alignment: 'center',
            fillColor: '#CCFFFF',
            margin: [0, -2, 0, -2]
          },
          {
            text: this.getSkillLevelMark(filteredData, name, '実践経験ある'),
            style: 'infoSk',
            bold: true,
            alignment: 'center',
            fillColor: '#CCFFFF',
            margin: [0, -2, 0, -2]
          },
          {
            text: this.getSkillLevelMark(filteredData, name, '一人で実践可能'),
            style: 'infoSk',
            bold: true,
            alignment: 'center',
            fillColor: '#CCFFFF',
            margin: [0, -2, 0, -2]
          },
          {
            text: this.getSkillLevelMark(filteredData, name, 'ユーザー指導可能'),
            style: 'infoSk',
            bold: true,
            alignment: 'center',
            fillColor: '#CCFFFF',
            margin: [0, -2, 0, -2]
          },
        );
        if (row.some(cell => cell !== null && cell !== undefined && cell != [])) { // テーブルのデータがnull又はundefinedではないのみ追加
          tableBody.push(row);
        }

      });
    });

    const filteredTableBody = this.removeDuplicates(tableBody); // 重複するデータ削除

    return filteredTableBody;
  },

  // "○" 自動追加 
  generateRightSkillSheetTable(skillSheetData) {


    /**
     * テクニカル・スキルシート（右）
     * 
     */
    const header = [
      {
        text: '分\n\n類',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 28, 0, 0],
        fillColor: '#FFFFCC'
      },
      {
        text: [
          { text: '名   称\n\n\n', style: 'subHeaderSk' },
          { text: '(右下の該当セルに○を付ける)', style: 'subHeaderSkRed' }, // 赤色
        ],
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 40, 0, 0],
      },
      {
        text: '基\n本\n知\n識\nの\nみ',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 3, 0, 0],
        fillColor: '#CCFFFF'
      },
      {
        text: '実\n戦\n経\n験\nあ\nる',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 3, 0, 0],
        fillColor: '#CCFFFF'
      },
      {
        text: '一\n人\nで\n実\n践\n可\n能',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 1, 0, 0],
        fillColor: '#CCFFFF'
      },
      {
        text: 'ユ\n｜\nザ\n指\n導\n可\n能',
        style: 'subHeaderSk',
        alignment: 'center',
        margin: [0, 3, 0, 0],
        fillColor: '#CCFFFF'
      },
    ];


    const tableBody = [header];

    const classifications2 = [
      '開発言語',
      'ＤＢ',
      'グループ',
      '暗号化/情報漏えい対策',
      '取得資格',
      '語学',
      'ヒューマンスキル',
    ];

    const nameMapping2 = {
      開発言語: [
        "ASP / ASP.NET",
        ".NET系（VB/C#）",
        "C / C++ / VC++",
        "Visual Basic",
        "Office VBA",
        "VBScript",
        "JAVA",
        "COBOL",
        "PowerShell",
        "HTML / CSS",
        "AJAX",
        "JSP",
        "PHP",
        "XML",
        "ActionScript（　　　）",
        "JavaApplet / JavaScript",
        "Perl / Ruby / Python",
        "ShellScript（BASH）",
        "ＤＯＳバッチ",
        "ＵＷＳＣ",
        "その他（　　　　　）",
      ],
      ＤＢ: [
        "Oracle",
        "MS SQL Server",
        "MySql",
        "Access",
        "PostgreSQL",
        "Symfoware Server",
        "その他（　　　　）",
      ],
      グループ: [
        "Lotus Notes（Domino）",
        "MS Exchange",
        "MS Sharepoint",
        "その他（　　　　）",
      ],
      "暗号化/情報漏えい対策": [
        "Symantec Endpoint Protection",
        "Sophos Anti-Virus for Windows",
        "ウイルスバスターClient / Server",
        "McAfee VirusScan",
        "Soliton ZERONA",
        "SHieldWARE",
        "Systemwalker Desktop Keeper",
        "i-FILTER",
        "秘文",
        "IDS / IPS / UTM",
        "Firewall（　　　　　　）",
        "パケットアナライザ",
        "その他（　　　　　　）",
      ],
      "取得資格": [
        " ",
        " ",
        " ",
        " ",
        " ",
        " ",
      ],
      "語学": [
        " ",
        " ",
        " ",
        " ",
      ],

      "ヒューマンスキル": [
        "",
        "組織の指導力",
        "企画力・提案力",
        "迅速・的確な判断力",
        "調整力・交渉力",
        "推進力・実行力",
        "高生産性・高効率性",

      ],
    };

    classifications2.forEach((classification) => {
      const toDisplayString = (str) => str.replace(/ー/g, "｜");
      const categoryNames = nameMapping2[classification] || [];
      const filteredData = skillSheetData.filter(item => item.classification === classification);
      if (classification != "ヒューマンスキル" && classification != "取得資格" && classification != "語学") {
        categoryNames.forEach((name, index) => {

          let row = [];

          if (classification === "開発言語") {
            row.push(
              index === 0
                ? { text: toDisplayString(classification), margin: [0, 72, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
                : '', // 右の分類
            );
          }

          if (classification === "ＤＢ") {
            row.push(
              index === 0
                ? { text: toDisplayString(classification), margin: [0, 20, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
                : '', // 右の分類
            );
          }

          if (classification === "グループ") { // 縦書き文字のサイズによってテーブルが拡大されたため、追加しました
            row.push(
              index === 0
                ? { text: toDisplayString(classification), margin: [0, 0, 0, 0], fontSize: 6, alignment: 'center', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
                : '', // 右の分類
            );
          }

          if (classification === "暗号化/情報漏えい対策") {
            row.push(
              index === 0
                ? { text: toDisplayString(classification), margin: [0, 2, 0, 0], style: 'infoHeaderSk', rowSpan: categoryNames.length, fillColor: '#FFFFCC' }
                : '', // 右の分類
            );
          }


          row.push(
            { text: name, style: 'infoSk', alignment: 'left' }, //右の名称
            {
              text: this.getSkillLevelMark(filteredData, name, '基本知識のみ'),
              style: 'infoSk',
              alignment: 'center',
              fillColor: '#CCFFFF',
              margin: [0, -2, 0, -2]
            },
            {
              text: this.getSkillLevelMark(filteredData, name, '実戦経験ある'),
              style: 'infoSk',
              alignment: 'center',
              fillColor: '#CCFFFF',
              margin: [0, -2, 0, -2]
            },
            {
              text: this.getSkillLevelMark(filteredData, name, '一人で実践可能'),
              style: 'infoSk',
              alignment: 'center',
              fillColor: '#CCFFFF',
              margin: [0, -2, 0, -2]
            },
            {
              text: this.getSkillLevelMark(filteredData, name, 'ユーザー指導可能'),
              style: 'infoSk',
              alignment: 'center',
              fillColor: '#CCFFFF',
              margin: [0, -2, 0, -2]
            },
          );
          if (row.some(cell => cell !== null && cell !== undefined)) { // テーブルのデータがnull又はundefinedではないのみ追加
            tableBody.push(row);
          }
        });
      } else if (classification == "ヒューマンスキル") {

        // Header追加
        const headerRow = [
          { text: toDisplayString(classification), style: 'infoHeaderSkPlus', margin: [0, 0, 0, 0], rowSpan: categoryNames.length, alignment: 'center', fillColor: '#FFFFCC' },
          { text: '', style: 'infoSk', fillColor: '#E0E0E0', alignment: 'center' },
          { text: '不得意', style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center' },
          { text: '人並み', style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center' },
          { text: '得意', style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center' },
          { text: '超得意', style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center' },
        ];

        tableBody.push(headerRow);

        categoryNames.forEach((name) => {
          const row = [
            {},
            { text: name, style: 'infoSk', alignment: 'left' },
            { text: this.getSkillLevelMark(filteredData, name, '不得意'), style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center', margin: [0, -2, 0, -2] },
            { text: this.getSkillLevelMark(filteredData, name, '人並み'), style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center', margin: [0, -2, 0, -2] },
            { text: this.getSkillLevelMark(filteredData, name, '得意'), style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center', margin: [0, -2, 0, -2] },
            { text: this.getSkillLevelMark(filteredData, name, '超得意'), style: 'infoSk', fillColor: '#CCFFFF', alignment: 'center', margin: [0, -2, 0, -2] },
          ];

          if (row.length === headerRow.length && row[1].text) {
            tableBody.push(row);
          } else {
            console.error('Row length mismatch:', row.length, headerRow.length);
          }
        });
      }else if (classification == "取得資格") {
         let count = 0;
         const leftColSpan = 1;
         const rightColSpan = header.length - 2;
       
         categoryNames.forEach((name, index) => {
           const nameText = filteredData[count]?.name ?? " ";
           const skillText = filteredData[count]?.skillLevel ?? " ";
       
           const row = [
             index === 0
               ? {
                   text: classification,
                   style: 'infoHeaderSk',
                   margin: [0, 5, 0, 0],
                   rowSpan: categoryNames.length,
                   alignment: 'center',
                   fillColor: '#FFFFCC'
                 }
               : '',
             {
               text: this.truncateTextToFit(nameText, 10, 6, 1.2, 35),
               style: 'infoSk',
               alignment: 'left',
               colSpan: leftColSpan,
             },
             {
               text: this.truncateTextToFit(skillText, 10, 6, 1.2, 140),
               style: 'infoSk',
               alignment: 'left',
               colSpan: rightColSpan,
               fillColor: '#CCFFFF'
             },
             ...Array(rightColSpan - 1).fill('')
           ];
       
           if (row.length === header.length) {
             tableBody.push(row);
           } else {
             console.error('Row length mismatch:', row.length, header.length, row);
           }
       
           count++;
         });
       }else if (classification == "語学") {
         let count = 0;
       
         categoryNames.forEach((name, index) => {
           const skillText = filteredData[count]?.skillLevel ?? " ";
       
           const row = [
             index === 0
               ? {
                   text: classification,
                   style: 'infoHeaderSk',
                   margin: [0, 6, 0, 0],
                   rowSpan: categoryNames.length,
                   alignment: 'center',
                   fillColor: '#FFFFCC'
                 }
               : '',
             {
               text: this.truncateTextToFit(skillText, 10, 6, 1.2, 70),
               style: 'infoSk',
               alignment: 'left',
               colSpan: header.length - 1,
             },
             ...Array(header.length - 2).fill(''),
           ];
       
           if (row.length === header.length) {
             tableBody.push(row);
           } else {
             console.error('Row length mismatch:', row.length, header.length, row);
           }
       
           count++;
         });
       }
        else {
          console.log("分野を見つかりませんでした。");
       }

    });
    const filteredTableBody = this.removeDuplicates(tableBody); // 重複するデータ削除
    
    return filteredTableBody;
  },

  skillSheetText(skillSheetDatas) {

    let itemText = [];

    itemText = this.generateCareerItems(skillSheetDatas);

    const skillSheetLeftTable = this.generateLeftSkillSheetTable(skillSheetDatas.skillSheetData);
    const skillSheetRightTable = this.generateRightSkillSheetTable(skillSheetDatas.skillSheetData);

    const careerStaffName = this.truncateTextToFit(skillSheetDatas.careerData.staffName, 20, 10, 1.2, 12)

    const academic = this.truncateTextToFit(skillSheetDatas.careerData.academic, 20, 10, 1.2, 12)

    const nearestStation = this.truncateTextToFit(skillSheetDatas.careerData.nearestStation, 20, 10, 1.2, 12)

    // 印刷のプレビュー画面の戻り値
    return [
      { text: '職務経歴書', style: 'headerC', alignment: 'center', margin: [0, 0, 0, 30] }, // タイトル

      /**
       * 氏名, 最終学歴
       */
      {
        columns: [
          { text: '氏名 ：', width: 45, margin: [-1, 0, 0, 0] },
          {
            stack: [
              { text: `${careerStaffName}`, width: 200, margin: [-5, 0, 0, 0] },
              {
                canvas: [
                  { type: 'line', x1: 0, y1: 0, x2: 245, y2: 0, dash: { length: 0.8, space: 1 } }
                ],
                absolutePosition: { x: 40, y: 105 }
              }
            ]
          },
          { text: '最終学歴 ：', width: 140, margin: [-36, 0, 0, 0] },
          {
            stack: [
              { text: `${academic}`, width: '*', margin: [-115, 0, 10, 0] },
              {
                canvas: [
                  { type: 'line', x1: 0, y1: 0, x2: 245, y2: 0, dash: { length: 0.8, space: 1 } }
                ],
                absolutePosition: { x: 304, y: 105 }
              }
            ]
          }
        ],
        style: 'infoC',
        columnGap: 5,
        margin: [0, 0, 0, 0],
      },
      

      /**
       * "性別/年齢, 最寄り駅"
       */
      {
        columns: [
          { text: "性別/年齢 ：", width: 64.5, margin: [-1, 2, 0, 0] },
          {
            stack: [
           { text: `${skillSheetDatas.careerData.gender? skillSheetDatas.careerData.gender + '  /  ' : ''}${skillSheetDatas.careerData.age}`
          },
          {
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 245, y2: 0, dash: { length: 0.8, space: 1 } }
            ],
            absolutePosition: { x: 40, y: 120 }
          }
          ],
          },
          { text: '最寄り駅 ：', width: 80, margin: [-55, 2, 0, 0] },
          {
            stack: [
            {text: `${nearestStation}`, margin: [-75,2,0,0]},

              {
                canvas: [
                  { type: 'line', x1: 0, y1: 0, x2: 245, y2: 0, dash: { length: 0.8, space: 1 } }
                ],
                absolutePosition: { x: 304, y: 120 }
              }
            ]
          },
        ],
        style: 'infoC',
        columnGap: 5,
        margin: [0, 0, 0, 10],
      },

      /**
       * 略歴
       */
      {
        table: {
          widths: [500],
          heights: [10, 125],
          body: [[{ text: '略歴', style: 'subheaderC', alignment: 'center', fillColor: '#bcbcbc' }],

          [{ text: this.truncateTextToFit(skillSheetDatas.careerData.biography, 110, 10, 1.2, 95), style: 'infoC', border: [true, true, true, false], }]], // LEFT, TOP, RIGHT, BOTTOM
          dontBreakRows: true,
        },
        margin: [0, 0, 0, 0],

        layout: {
          hLineWidth: function () {
            return 0.5;
          },
          vLineWidth: function () {
            return 0.5;
          },
        },
      },

      /**
       *  自己PR
       */
      {
        table: {
          widths: [500],
          heights: [10, 230],
          body: [
            [
              {
                text: '自己PR', style: 'subheaderC', alignment: 'center', fillColor: '#bcbcbc'

              }
            ],
            [
              {
                text: this.truncateTextToFit(skillSheetDatas.careerData.publicRelations, 190, 10, 1.2, 100), style: 'infoC', border: [true, true, true, false]

              }
            ]
          ]
          , dontBreakRows: true,
        },
        margin: [0, 0, 0, 0],

        layout: {
          hLineWidth: function () {
            return 0.5;
          },
          vLineWidth: function () {
            return 0.5;
          },
        },
      },

      /**
       *  得意分野
       */
      {
        table: {
          widths: [500],
          heights: [10, 70],
          body: [
            [
              {
                text: '得意分野', style: 'subheaderC', alignment: 'center', fillColor: '#bcbcbc'
              }
            ],
            [
              {
                text: this.truncateTextToFit(skillSheetDatas.careerData.specialtyField, 60, 10, 1.2, 95), style: 'infoC', border: [true, true, true, false]
              }
            ]
          ]
          , dontBreakRows: true,
        },
        margin: [0, 0, 0, 0],

        layout: {
          hLineWidth: function () {
            return 0.5;
          },
          vLineWidth: function () {
            return 0.5;
          },
        },
      },

      /**
       *  保有資格
       */

      {
        table: {
          widths: [500],
          heights: [10, 120],
          // heights: ['*'], // 後で修正「ページ数は固定なのか？」
          body: [
            [
              {
                text: '保有資格', style: 'subheaderC', alignment: 'center', fillColor: '#bcbcbc'
              }
            ],
            [
              {
                text: this.truncateTextToFit(skillSheetDatas.careerData.qualification, 100, 10, 1.2, 94), border: [true, true, true, true], style: 'infoC'
              }
            ]
          ],
          dontBreakRows: true,
        },
        margin: [0, 0, 0, 10],

        layout: {
          hLineWidth: function () {
            return 0.5;
          },
          vLineWidth: function () {
            return 0.5;
          },
        },

      },


      //--------------------------------------------------------------------------------------------------------------

      /**
       *  業務関連
       */

      // タイトルを追加
      { text: '職務経歴書', style: 'headerCI', alignment: 'center', margin: [0, 0, 0, 30],fontSize: 16, lineHeight: 1.2 },

      {
        table: {
          // headerRows: 1,  //次のページに移動された場合、'職務経歴書'のそのまま形式に合わせて作成する
          keepWithHeaderRows: true,
          widths: [10, 70, 260, 60, 68],
          body: itemText
        },
        pageBreak: 'after',
        margin: [0, 0, 0, 10],
        heights: [0, 0, 0, 0],

        layout: {
          hLineWidth: function () {
            return 0.5;
          },
          vLineWidth: function () {
            return 0.5;
          },
        },
      },

      //--------------------------------------------------------------------------------------------------------------

      /**
       *  テクニカル・スキルシート出力
       */

      { text: 'テクニカル・スキルシート', style: 'headerSk', alignment: 'center', margin: [0, -20, 0, 10] }, // LEFT, TOP, RIGHT, BOTTOM

      {
        columns: [
          {
            width: '50%',
            table: {
              widths: [6, 110, 20, 20, 20, 20],
              body: skillSheetLeftTable,
            },
            layout: {
              // hLineWidth: function (i) {
              //   return (i === 57) ? 1 : 0.5;
              // },
              // vLineWidth: function (i) {
              //   return (i === 5) ? 1 : 0.5;
              // },

              hLineWidth: function () {
                return 0.5;
              },
              vLineWidth: function () {
                return 0.5;
              },


              hLineStyle: function (i, node) { return (i === 0 || i === 1 || i === 17 || i === 30 || i === 41 || i === 47 || i === 54 || i === 61 || i === node.table.body.length) ? null : { dash: { length: 0.5, space: 0.8 } }; },
              hLineColor: function (i, node) {
                return (i === 0 || i === 1 || i === 17 || i === 30 || i === 41 || i === 47 || i === 54 || i === 61 || i === node.table.body.length) ? 'black' : 'gray';
              }
            },
          },
          // Right Table
          {
            width: '50%',
            table: {
              widths: [6, 110, 20, 20, 20, 20],
              body: skillSheetRightTable,
            },
            layout: {

              // hLineWidth: function (i) {
              //   return (i === 22) ? 1 : 0.5;
              // },
              // vLineWidth: function (i) {
              //   return (i === 1) ? 1 : 0.5;
              // },

              hLineWidth: function () {
                return 0.5;
              },
              vLineWidth: function () {
                return 0.5;
              },

              hLineStyle: function (i, node) {
                if (i === 0 || i === 1 || i === 22 || i === 29 || i === 33 || i === 46 || i === 52 || i === 56 || i === 57) {
                  return null; // 
                }
                return (i === 0 || i === node.table.body.length) ? null : { dash: { length: 0.5, space: 0.8 } };
              },
              hLineColor: function (i, node) {
                return (i === 0 || i === 1 || i === 22 || i === 29 || i === 33 || i === 46 || i === 52 || i === 56 || i === 57 || i === node.table.body.length) ? 'black' : 'gray';
              },
            },
          },
        ],
      },

    ];
  }
};
